import {classNames, layout, MaterialIcon, PushButton, usePlatform} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useState} from "react";
import {stylesheet} from "typestyle";
import {SignUpDialog} from "../signup";
import {ShopHomeViewProps} from "../types";
import {HowItWorks} from "./HowItWorks";
import {useLocalization} from "../../i18n";


export function DryCleaningHomeView({shop, onBack}: ShopHomeViewProps) {

    const [signUpOpen, setSignUpOpen] = useState(false);
    const handleOpenSignUpClick = useCallback(() => setSignUpOpen(true), []);
    const handleCloseSignUpClick = useCallback(() => setSignUpOpen(false), []);

    const {t} = useLocalization();

    return (
        <div className={classNames(styles.home, layout.vertical)}>

            {onBack && (
                <div className={styles.backContainer}>
                    <PushButton onClick={onBack} icon={MaterialIcon.arrow_back}>
                        {t("Back")}
                    </PushButton>
                </div>
            )}

            <div className={classNames(layout.fill, layout.vertical, styles.howItWorks)}>
                <HowItWorks/>
            </div>

            <div className={styles.signUpButtonContainer}>
                <PushButton primary onClick={handleOpenSignUpClick}>
                    {t("SignUpNow")}
                </PushButton>
            </div>

            <SignUpDialog
                open={signUpOpen}
                shop={shop}
                onClose={handleCloseSignUpClick}
            />
        </div>
    );
}

const styles = stylesheet({
    home: {
        width: "100%",
        height: "100%",
    },
    backContainer: {
        padding: "0.75em 1.5em"
    },
    howItWorks: {
        background: "rgba(255, 255, 255, 0.5)",
        margin: "0.75em 1.5em",
        padding: "1.5em 1.5em 0.75em 1.5em",
    },
    signUpButtonContainer: {
        padding: "0.75em 1.5em"
    },
});

